(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });
      const prodPageSwiper = new Swiper('#featured-product-swiper', {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
      });
      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();
      document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    connectedCallback() {
      this.handleClickOutside = this.handleClickOutside.bind(this);
      document.addEventListener('click', this.handleClickOutside);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		}
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if(this.header.classList.contains('header-overlay')){
			this.header.classList.remove('color-background-4');
			this.header.classList.add('overlay-effect');
			this.header.classList.remove('color-background-overlay');
		}
		const headerMobile = document.querySelector('.header-mobile-section');

		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.remove('color-background-4');
			headerMobile.classList.add('overlay-effect');
			headerMobile.classList.remove('color-background-overlay');
		}
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		const headerMobile = document.querySelector('.header-mobile-section');

		if(this.header.classList.contains('header-overlay')){
			this.header.classList.add('color-background-4');
			this.header.classList.remove('color-background-1');
			this.header.classList.remove('overlay-effect');
			this.header.classList.add('color-background-overlay');
		}

		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.add('color-background-4');
			headerMobile.classList.remove('color-background-1');
			headerMobile.classList.remove('overlay-effect');
			headerMobile.classList.add('color-background-overlay');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });
      const prodPageSwiper = new Swiper('#product-page-swiper', {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
        pagination: {
          el: '.swiper-pagination-product-page',
          clickable: true,
        },
        //on: {
        //	click: function (e) {
        //			if (this.zoom.scale === 1) {
        //			this.zoom.in();
        //			} else {
        //				this.zoom.out();
        //			}
        //	 },
        //},
      });
      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();
      document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function appHeight() {
      const doc = document.documentElement;
      doc.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
    }

    //window.addEventListener('resize', appHeight);
    appHeight();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uwaga-journal-index"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-uji-filter]');
    if(!button)return;
    var root=button.closest('[data-uji]');
    root.querySelectorAll('[data-uji-filter]').forEach(function(item){item.classList.toggle('is-active',item===button)});
    var filter=button.dataset.ujiFilter;
    root.querySelectorAll('[data-uji-card]').forEach(function(card){
      card.classList.toggle('is-hidden',filter!=='all'&&!card.dataset.tags.includes(filter));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uwaga-maharishi-collection"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.addEventListener('click',function(e){
      var r=e.target.closest('[data-umc]');if(!r)return;
      var d=r.querySelector('[data-umc-drawer]'),s=r.querySelector('[data-umc-shade]');
      if(e.target.closest('[data-umc-menu]')){d.classList.add('is-open');s.classList.add('is-open');d.setAttribute('aria-hidden','false')}
      if(e.target.closest('[data-umc-close]')||e.target.closest('[data-umc-shade]')){d.classList.remove('is-open');s.classList.remove('is-open');d.setAttribute('aria-hidden','true')}
      var b=e.target.closest('[data-cols]');
      if(b){r.querySelector('[data-umc-grid]').dataset.cols=b.dataset.cols;r.querySelectorAll('[data-cols]').forEach(function(x){x.classList.toggle('is-active',x===b)})}
    })
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uwaga-maharishi-home"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(!root||root.dataset.umReady)return;root.dataset.umReady='1';var rail=root.querySelector('[data-um-products]'),cards=rail?Array.from(rail.querySelectorAll('[data-um-card]')):[],drawer=root.querySelector('[data-um-drawer]'),overlay=root.querySelector('[data-um-overlay]'),current=root.querySelector('[data-um-current]');function width(){return cards[0]?cards[0].getBoundingClientRect().width:rail.clientWidth}function update(){if(!rail||!cards.length)return;var index=Math.round(rail.scrollLeft/width());index=Math.max(0,Math.min(cards.length-1,index));if(current)current.textContent=String(index+1).padStart(2,'0')}function go(direction){if(!rail||!cards.length)return;var index=Math.round(rail.scrollLeft/width());var next=index+direction;if(next<0)next=cards.length-1;if(next>=cards.length)next=0;rail.scrollTo({left:next*width(),behavior:'smooth'})}root.addEventListener('click',function(e){if(e.target.closest('[data-um-menu]')){drawer.classList.add('is-open');overlay.classList.add('is-open');drawer.setAttribute('aria-hidden','false')}if(e.target.closest('[data-um-close]')||e.target.closest('[data-um-overlay]')){drawer.classList.remove('is-open');overlay.classList.remove('is-open');drawer.setAttribute('aria-hidden','true')}if(e.target.closest('[data-um-next]'))go(1);if(e.target.closest('[data-um-prev]'))go(-1)});if(rail){rail.addEventListener('scroll',update,{passive:true});update()}}document.querySelectorAll('[data-um-home]').forEach(init);document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-um-home]'))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uwaga-maharishi-product-v2"] && !Shopify.designMode) return;
  try {
    
(function(){var selected='',index=0;function root(e){return e.closest('[data-maha-product]')}function openSheet(r){r.querySelector('[data-size-sheet]').classList.add('open');r.querySelector('[data-sheet-close]').classList.add('open')}function closeSheet(r){r.querySelector('[data-size-sheet]').classList.remove('open');r.querySelector('.maha-sheet-shade').classList.remove('open')}function sources(r){return Array.from(r.querySelectorAll('[data-slide] img')).map(function(x){return x.currentSrc||x.src})}function light(r){r.querySelector('[data-lightbox-image]').src=sources(r)[index]}async function add(r){if(!selected){openSheet(r);return}var fd=new FormData(r.querySelector('#maha-product-form'));var res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});if(res.ok){r.querySelector('[data-added-size]').textContent=selected;r.querySelector('[data-added]').classList.add('open')}}document.addEventListener('click',function(e){var r=root(e.target);if(!r)return;if(e.target.closest('[data-menu-open]')){r.querySelector('[data-menu]').classList.add('open');r.querySelector('.maha-shade').classList.add('open')}if(e.target.closest('[data-menu-close]')){r.querySelector('[data-menu]').classList.remove('open');r.querySelector('.maha-shade').classList.remove('open')}if(e.target.closest('[data-size-open]'))openSheet(r);if(e.target.closest('[data-sheet-close]'))closeSheet(r);var c=e.target.closest('[data-choice]');if(c&&!c.disabled){selected=c.dataset.size;r.querySelector('[data-variant]').value=c.dataset.id;r.querySelector('[data-price]').textContent=c.dataset.priceValue;r.querySelector('[data-buy-action]').textContent='ADD TO CART — '+selected;r.querySelector('.maha-guide-add').disabled=false;r.querySelector('.maha-guide-add').classList.add('ready');closeSheet(r)}if(e.target.closest('[data-buy-action]'))add(r);if(e.target.closest('[data-guide-open]'))r.querySelector('[data-guide]').showModal();if(e.target.closest('[data-guide-close]'))r.querySelector('[data-guide]').close();if(e.target.closest('[data-guide-select]')){r.querySelector('[data-guide]').close();openSheet(r)}if(e.target.closest('[data-guide-add]'))add(r);if(e.target.closest('[data-zoom]')){light(r);r.querySelector('[data-lightbox]').showModal()}if(e.target.closest('[data-lightbox-close]'))r.querySelector('[data-lightbox]').close();if(e.target.closest('[data-prev]')){index=(index-1+sources(r).length)%sources(r).length;light(r)}if(e.target.closest('[data-next]')){index=(index+1)%sources(r).length;light(r)}if(e.target.closest('[data-added-close]'))r.querySelector('[data-added]').classList.remove('open')});document.addEventListener('scroll',function(){document.querySelectorAll('[data-maha-product]').forEach(function(r){var g=r.querySelector('[data-gallery]');index=Math.round(g.scrollLeft/g.clientWidth);r.querySelectorAll('.maha-dots i').forEach(function(d,j){d.classList.toggle('active',j===index)})})},true);document.addEventListener('change',function(e){if(e.target.name==='unit'){var t=e.target.closest('.maha-chart').querySelector('.maha-table'),inch=e.target.value==='in';t.querySelectorAll('span').forEach(function(s){var n=parseFloat(s.textContent);s.textContent=inch?(n/2.54).toFixed(1):s.dataset.cm||n;s.dataset.cm=s.dataset.cm||n})}})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uwaga-maharishi-product"] && !Shopify.designMode) return;
  try {
    
(function(){function root(e){return e.target.closest('[data-ump]')}function imgs(r){return Array.from(r.querySelectorAll('[data-ump-slide] img')).map(function(i){return i.currentSrc||i.src})}function sheet(r,on){r.querySelector('[data-ump-size-sheet]').classList.toggle('is-open',on);r.querySelector('[data-ump-sheet-shade]').classList.toggle('is-open',on)}function pick(r,b){r.querySelector('[data-ump-variant]').value=b.dataset.id;r.dataset.size=b.dataset.size;r.dataset.price=b.dataset.price;r.querySelector('[data-ump-price]').textContent=b.dataset.price;r.querySelector('[data-ump-action]').textContent=(document.documentElement.lang.indexOf('it')===0?'AGGIUNGI AL CARRELLO — ':'ADD TO CART — ')+b.dataset.size}async function add(r){var id=r.querySelector('[data-ump-variant]').value,button=r.querySelector('[data-ump-guide-add]'),guide=r.querySelector('[data-ump-guide]');if(button){button.disabled=true;button.setAttribute('aria-busy','true')}try{var sections=['cart-drawer','cart-icon-bubble','cart-icon-bubble-mobile'],res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}],sections:sections,sections_url:window.location.pathname})}),item=await res.json();if(!res.ok)throw new Error(item.description||item.message||'Cart error');if(guide&&guide.open)guide.close();try{var drawer=document.querySelector('cart-drawer');if(drawer&&item.sections&&typeof drawer.renderContents==='function'){drawer.renderContents(item)}else if(item.sections){sections.forEach(function(key){var target=document.getElementById('shopify-section-'+key),html=item.sections[key];if(target&&html){var parsed=new DOMParser().parseFromString(html,'text/html'),source=parsed.getElementById('shopify-section-'+key);if(source)target.innerHTML=source.innerHTML}})}}catch(renderError){console.warn('UWAGA cart UI refresh recovered',renderError)}var cart=await fetch('/cart.js',{headers:{'Accept':'application/json','Cache-Control':'no-cache'}}).then(function(x){if(!x.ok)throw new Error('Cart state error');return x.json()});document.querySelectorAll('[data-ump-cart-count]').forEach(function(x){x.textContent=cart.item_count;x.hidden=cart.item_count<1});document.dispatchEvent(new CustomEvent('cart:change',{detail:{cart:cart}}));document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart:cart}}));var size=r.querySelector('[data-ump-added-size]'),price=r.querySelector('[data-ump-added-price]'),notice=r.querySelector('[data-ump-added]');if(size)size.textContent=r.dataset.sizeLabel+': '+r.dataset.size;if(price)price.textContent=r.dataset.price;if(notice){notice.classList.add('is-open');notice.setAttribute('aria-hidden','false')}}catch(error){console.error('UWAGA cart add failed',error);if(button)button.textContent=document.documentElement.lang.indexOf('it')===0?'RIPROVA':'TRY AGAIN'}finally{if(button){button.disabled=false;button.removeAttribute('aria-busy')}}}document.addEventListener('click',function(e){var r=root(e);if(!r)return;var d=r.querySelector('[data-ump-drawer]'),sh=r.querySelector('[data-ump-shade]');if(e.target.closest('[data-ump-menu]')){d.classList.add('is-open');sh.classList.add('is-open')}if(e.target.closest('[data-ump-menu-close]')||e.target.closest('[data-ump-shade]')){d.classList.remove('is-open');sh.classList.remove('is-open')}if(e.target.closest('[data-ump-action]')){r.dataset.size?add(r):sheet(r,true)}if(e.target.closest('[data-ump-sheet-close]')||e.target.closest('[data-ump-sheet-shade]'))sheet(r,false);var c=e.target.closest('[data-ump-choice]');if(c&&!c.disabled){pick(r,c);sheet(r,false)}var gc=e.target.closest('[data-ump-guide-choice]');if(gc&&!gc.disabled){pick(r,gc);r.querySelectorAll('[data-ump-guide-choice]').forEach(function(x){x.classList.toggle('is-active',x===gc)});r.querySelector('[data-ump-guide-add]').disabled=false}if(e.target.closest('[data-ump-guide-add]'))add(r);if(e.target.closest('[data-ump-guide-open]'))r.querySelector('[data-ump-guide]').showModal();if(e.target.closest('[data-ump-guide-close]'))r.querySelector('[data-ump-guide]').close();var z=e.target.closest('[data-ump-zoom]');if(z){r.dataset.index=z.dataset.umpZoom;r.querySelector('[data-ump-lightbox-img]').src=imgs(r)[Number(r.dataset.index)];r.querySelector('[data-ump-lightbox]').showModal()}if(e.target.closest('[data-ump-lightbox-close]'))r.querySelector('[data-ump-lightbox]').close();if(e.target.closest('[data-ump-prev]')||e.target.closest('[data-ump-next]')){var a=imgs(r),n=e.target.closest('[data-ump-next]')?1:-1;r.dataset.index=(Number(r.dataset.index)+n+a.length)%a.length;r.querySelector('[data-ump-lightbox-img]').src=a[Number(r.dataset.index)]}if(e.target.closest('[data-ump-added-close]'))r.querySelector('[data-ump-added]').classList.remove('is-open')});document.addEventListener('scroll',function(){document.querySelectorAll('[data-ump]').forEach(function(r){var g=r.querySelector('[data-ump-gallery]'),i=Math.round(g.scrollLeft/g.clientWidth);r.querySelector('[data-ump-zoom]').dataset.umpZoom=i;r.querySelectorAll('.ump__dots i').forEach(function(x,j){x.classList.toggle('is-active',i===j)})})},true);document.addEventListener('change',function(e){var r=e.target.closest('[data-ump]');if(!r)return;if(e.target.matches('[name="unit"]'))r.querySelectorAll('[data-cm]').forEach(function(row){var vals=row.dataset.cm.split(',').map(Number);row.querySelectorAll('td').forEach(function(td,i){td.textContent=e.target.value==='cm'?vals[i]:(vals[i]/2.54).toFixed(1)})});if(e.target.matches('[data-ump-measure]'))r.querySelectorAll('[data-measure]').forEach(function(x){x.hidden=x.dataset.measure!==e.target.value})})})();

  } catch(e) { console.error(e); }
})();
})();
